import { copyPaymentPlansApi, getPublicPaymentPlansApiV2, getPaymentPlansApiV2, syncPaymentPlansApi, } from '../api/paymentPlans';
export const emptyGroups = [
    {
        id: '0', name: 'Down payment', code: 'down_payment', sortOrder: 0, installments: [],
    },
    {
        id: '1', name: 'Before handover', code: 'before_handover', sortOrder: 1, installments: [],
    },
    {
        id: '2', name: 'On handover', code: 'on_handover', sortOrder: 2, installments: [],
    },
    {
        id: '3', name: 'After handover', code: 'after_handover', sortOrder: 3, installments: [],
    },
];
const paymentPlansActionsNew = {
    getPaymentPlans: async ({ projectId }, { setState }) => {
        try {
            const { data: res } = await getPaymentPlansApiV2(projectId);
            setState((state) => {
                state.paymentPlansNew = res.data;
            });
            const resultWithEmptyGroups = res.data.map((plan) => {
                const seenGroupCodes = new Set();
                return ({
                    ...plan,
                    groups: [...plan.groups, ...emptyGroups]
                        .filter((group) => {
                        const isDuplicate = seenGroupCodes.has(group.code);
                        seenGroupCodes.add(group.code);
                        return !isDuplicate;
                    })
                        .sort((a, b) => a.sortOrder - b.sortOrder),
                });
            });
            return ({ total: res.total, data: resultWithEmptyGroups });
        }
        catch (err) {
            const error = err;
            throw error.response?.data.message;
        }
    },
    getPublicPaymentPlans: async ({ projectId }, { setState }) => {
        try {
            const { data: res } = await getPublicPaymentPlansApiV2(projectId);
            setState((state) => {
                state.publicPaymentPlansNew = res.data;
            });
            return (res);
        }
        catch (err) {
            const error = err;
            throw error.response?.data.message;
        }
    },
    syncPaymentPlans: async ({ data }, { setState }) => {
        try {
            const parsedPlans = data.plans.map((plan) => ({
                ...plan,
                id: plan.id?.length === 36 ? plan.id : undefined,
                groups: plan.groups
                    ?.filter((group) => group.installments.length > 0)
                    .map((group) => ({
                    ...group,
                    id: typeof group.id === 'number' ? undefined : group.id,
                    installments: group.installments.map((installment) => ({
                        ...installment,
                        id: installment.id?.length === 36 ? installment.id : undefined,
                        amount: ({ ...installment.amount, value: Number(installment.amount.value) }),
                    })),
                })),
            }));
            const { data: res } = await syncPaymentPlansApi({ projectId: data.projectId, plans: parsedPlans });
            setState((state) => {
                state.paymentPlansNew = res.data;
            });
            return res;
        }
        catch (err) {
            const error = err;
            throw error.response?.data.message;
        }
    },
    copyPaymentPlans: async ({ data, projectId }) => {
        try {
            const { data: res } = await copyPaymentPlansApi(projectId, data);
            return res;
        }
        catch (err) {
            const error = err;
            throw error.response?.data.message;
        }
    },
};
export default paymentPlansActionsNew;
